import { useQuery } from '@tanstack/react-query';

import { paymentsApi } from '@/lib/api/payments.api';

export function usePayments(query?: { status?: string; page?: number; limit?: number }) {
  return useQuery({
    queryKey: ['payments', query],
    queryFn: () => paymentsApi.getPaymentLinks(query),
  });
}

export function usePaymentsByCall(callId: string | undefined) {
  return useQuery({
    queryKey: ['payments', 'by-call', callId],
    queryFn: () => paymentsApi.getPaymentLinksByCall(callId!),
    enabled: !!callId,
  });
}
